import React from 'react';
import './AlarmsGrid.scss';
import isEmpty from 'lodash/isEmpty';
// Material Ui
import { Grid, Stack } from '@mui/material';
import AlarmValuesDisplay from './AlarmValuesDisplay';
import { AlarmsGridInterface } from '../FullKpiGrid/types';
import LelySpinner from '../muiWrappers/LelySpinner/LelySpinner';

export default function AlarmsGrid({
  kpiDetails,
  entityName,
}: AlarmsGridInterface) {
  if (
    !isEmpty(kpiDetails) &&
    kpiDetails.infoGraphic &&
    kpiDetails.infoGraphic.totalAlarms
  ) {
    const setEntityName = entityName.replace(/ /g, '');
    const alarmsData = kpiDetails.infoGraphic.totalAlarms.statisticDetails;

    const alarmsLastWeekData = alarmsData.filter(
      (currentValue) => currentValue.name.indexOf('week') !== -1,
    );
    const alarmsLast24HData = alarmsData.filter(
      (currentValue) => currentValue.name.indexOf('24h') !== -1,
    );

    return (
      <Stack
        className={`robotStateGridWrapper ${setEntityName}`}
        sx={{ overflow: 'unset' }}
      >
        <Grid className="kpiStyle" size={3}>
          <Grid container direction="row">
            <AlarmValuesDisplay
              title="Alarms last 24h"
              alarmsData={alarmsLast24HData}
              externalId={kpiDetails.id}
              kpiDetails={kpiDetails}
              is24h
            />
            <AlarmValuesDisplay
              title="Alarms past 7 days"
              alarmsData={alarmsLastWeekData}
              externalId={kpiDetails.id}
              kpiDetails={kpiDetails}
              is24h={false}
            />
          </Grid>
        </Grid>
      </Stack>
    );
  }

  return (
    <div className="machineRobotStateGridWrapper">
      <div className="machineRobotStateSpinner">
        <LelySpinner />
      </div>
    </div>
  );
}
